var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _path22, _g3, _path23, _path24, _path25, _path26, _path27, _path28, _g4, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g5, _path38, _path39, _g6, _rect, _line, _line2, _line3, _line4, _line5, _path40, _path41, _g7, _path42, _path43, _g8, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalloween({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78535C42.3036 6.46852 45.1137 6.46852 47.3945 7.78535L76.7314 24.723C79.0122 26.0398 80.4172 28.4734 80.4172 31.1071V64.9824C80.4172 67.6161 79.0122 70.0497 76.7314 71.3665L47.3945 88.3042C45.1137 89.621 42.3036 89.621 40.0227 88.3042L10.6859 71.3665C8.40504 70.0497 7 67.6161 7 64.9824V31.1071C7 28.4734 8.40504 26.0398 10.6859 24.723L40.0228 7.78535Z",
    fill: "#D7C7F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8837_47745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8837_47745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8452 45.0004 11.8453 46.8535 12.9152L72.7845 27.8864C74.6377 28.9564 75.7793 30.9337 75.7793 33.0735V63.0161C75.7793 65.1559 74.6377 67.1332 72.7845 68.2032L46.8535 83.1744C45.0004 84.2444 42.7172 84.2444 40.864 83.1744L14.933 68.2032C13.0798 67.1332 11.9382 65.1559 11.9382 63.0161V33.0735C11.9382 30.9337 13.0798 28.9564 14.933 27.8864L40.864 12.9152Z",
    fill: "#8D61E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.0601C72.2298 83.5012 12.5546 43.3756 6.58582 9.86812L-27.8162 57.6639L55.5728 117.685L107.846 45.0601Z",
    fill: "#6236BD"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8837_47745)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8837_47745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 82,
    height: 82
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2998 8.42166C3.2998 5.11374 5.98141 2.43213 9.28934 2.43213H78.3993C81.7072 2.43213 84.3888 5.11373 84.3888 8.42166V49.9236C84.3888 52.2916 82.4692 54.2113 80.1012 54.2113C77.7332 54.2113 75.8136 56.1309 75.8136 58.4989V63.0136C75.8136 65.1547 74.6706 67.133 72.8157 68.2025L46.838 83.18C44.9853 84.2481 42.7037 84.2475 40.8517 83.1783L14.9121 68.203C13.0588 67.1331 11.9171 65.1558 11.9171 63.0159V58.5199C11.9171 56.1403 9.98809 54.2113 7.60848 54.2113C5.22886 54.2113 3.2998 52.2822 3.2998 49.9026V8.42166Z",
    fill: "#FCCE2C"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8837_47745)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8837_47745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 82,
    height: 82
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30005 8.41953C3.30005 5.1116 5.98165 2.42999 9.28958 2.42999H78.3996C81.7075 2.42999 84.3891 5.1116 84.3891 8.41952V54.2091H75.8138V63.0115C75.8138 65.1526 74.6709 67.1309 72.816 68.2003L46.8382 83.1779C44.9856 84.246 42.704 84.2454 40.8519 83.1761L14.9123 68.2009C13.0591 67.131 11.9174 65.1537 11.9174 63.0137V54.2091H3.30005V8.41953Z",
    fill: "#8D61E8"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8837_47745)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4419 21.5606C79.6925 22.9436 81.7221 25.9903 81.9309 28.2918C82.2832 32.1485 80.6901 37.7429 74.2208 40.5213C68.2772 43.0735 56.4733 38.2614 55.1077 34.875C53.742 31.4887 54.2161 24.0861 58.5729 19.3402C62.3188 15.2614 69.1316 16.4595 77.4419 21.5606Z",
    fill: "#E37230"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8837_47745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 16,
    width: 28,
    height: 26
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4424 21.5606C79.693 22.9436 81.7226 25.9903 81.9314 28.2919C82.2837 32.1486 80.6906 37.7429 74.2213 40.5214C68.2777 43.0735 56.4738 38.2614 55.1081 34.8751C53.7425 31.4887 54.2166 24.0862 58.5734 19.3403C62.3193 15.2614 69.1321 16.4595 77.4424 21.5606Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8837_47745)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0899 32.5792C53.4533 30.9846 53.835 29.4244 54.0579 27.7999C54.183 26.8896 54.2895 25.976 54.4544 25.074C54.5762 24.4147 55.0584 23.4335 55.0226 22.7936C55.2089 26.1458 55.0876 30.4171 57.4357 33.0458C58.5838 34.3301 60.1752 35.1135 61.763 35.7806C65.2376 37.2401 69.0615 38.2814 72.7765 37.534C75.5837 36.9696 78.1851 35.3658 79.9699 33.0955C81.7533 30.8278 82.7058 27.9133 82.601 25.0395C83.5893 31.3009 81.9826 38.1689 77.5669 42.7572C76.7075 43.6494 75.7427 44.455 74.6406 45.011C73.2748 45.697 71.7464 45.9702 70.2342 46.1105C68.5001 46.269 66.7452 46.2567 65.0383 45.9317C61.9334 45.3398 59.1222 43.7377 56.5328 41.9338C55.2263 41.0252 53.9123 40.0017 53.2263 38.5561C52.3586 36.7321 52.637 34.5672 53.0911 32.5833L53.0899 32.5792Z",
    fill: "#E37230"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.57
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2124 19.0705C69.1005 18.6029 67.9625 18.1761 66.7698 17.9821C65.0843 17.7106 63.3556 17.9207 61.6577 18.1306C59.9829 18.336 58.2465 18.566 56.8141 19.4815C57.1702 18.0836 57.5686 16.6159 58.587 15.5977C59.7181 14.4692 61.3894 14.1233 62.9677 13.9748C68.1466 13.4861 73.4413 14.5961 77.9643 17.1146C79.4047 17.9177 80.5163 19.1816 81.907 19.9882C83.0256 20.6396 83.9536 21.1674 84.1134 22.6382C84.3417 24.7394 82.547 26.5436 82.1721 28.6305C81.3863 26.1146 79.7211 24.4105 77.4432 23.3031C76.2016 22.7009 75.1116 21.6429 73.9171 20.9318C72.7277 20.2236 71.4882 19.6053 70.2124 19.0705Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0148 20.2728C74.8347 21.1422 76.8086 22.5683 77.0669 24.7381C76.3072 22.7389 74.5773 21.5977 73.0148 20.2728Z",
    fill: "#E37230"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2484 20.0463C69.4332 21.6002 68.6574 23.0896 67.8422 24.6435C68.1861 22.9306 69.037 21.3066 70.2484 20.0463Z",
    fill: "#E37230"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6804 18.3095C66.8992 18.4729 65.2398 18.822 63.5401 19.3841C65.0165 18.3651 66.9396 17.9656 68.6804 18.3095Z",
    fill: "#E37230"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9072 26.6301C80.2963 29.839 79.2241 33.1889 77.1447 35.669C76.878 35.9636 76.4784 36.3987 76.1826 36.6597C76.5798 36.1678 77.042 35.5286 77.3889 34.9983C78.9802 32.5058 79.8424 29.5755 79.9058 26.6328L79.9072 26.6301Z",
    fill: "#E37230"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9172 35.7324C73.1882 38.3871 71.6551 41.2653 68.9116 42.2359C68.644 42.3117 68.3408 42.4024 68.0724 42.4674C71.0539 41.3699 72.643 38.4953 73.9187 35.7298L73.9172 35.7324Z",
    fill: "#E37230"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8399 36.1941C62.4037 37.7724 61.7427 39.2703 60.9172 40.6835L60.8833 40.7442C60.7849 40.6513 60.7652 40.4845 60.8565 40.4003C60.8131 40.4904 60.8481 40.593 60.9103 40.6346L60.8372 40.6493C61.3224 39.081 61.9709 37.5934 62.8425 36.1956L62.8399 36.1941Z",
    fill: "#E37230"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1389 38.6774C55.8926 36.4484 55.4307 33.7253 55.8767 31.1863C55.9323 33.7625 56.3467 36.2341 57.1389 38.6774Z",
    fill: "#E37230"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7506 18.1372C62.1726 17.9431 61.6659 18.4293 61.1991 18.7093C59.7643 19.7272 58.7489 21.1869 58.1997 22.8823C58.3424 21.071 59.4977 19.3847 61.0529 18.4754C61.5518 18.2237 62.2168 17.7842 62.7532 18.1387L62.7506 18.1372Z",
    fill: "#E37230"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4872 26.4683C74.7929 22.5214 69.5032 22.8721 67.5185 24.7782L74.4872 26.4683Z",
    fill: "#2C0F59"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8346 21.0584C64.6177 18.756 64.7113 23.542 64.7113 23.542L60.8346 21.0584Z",
    fill: "#2C0F59"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0768 29.1519C75.9926 29.2538 71.0574 35.0555 65.5471 34.8954L66.4151 32.2488L63.2749 34.4699C62.7224 34.2727 62.1712 33.9999 61.624 33.6463C60.8047 33.1133 60.1537 32.5357 59.6392 31.9337L59.5916 28.9082L58.7702 30.6631C56.5235 26.4564 59.6954 21.6801 59.6954 21.6801C59.4762 22.5448 59.589 23.3834 59.957 24.1808L59.5384 27.4484L61.1343 25.8415C62.9531 27.711 66.1237 29.1463 69.2825 29.7025L68.3685 32.4931L72.4036 29.9468C73.77 29.9088 75.0375 29.6563 76.0756 29.1478L76.0768 29.1519Z",
    fill: "#2C0F59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0772 29.1523C76.0473 29.1876 75.4236 29.9203 74.3922 30.8516C73.555 31.1223 72.6144 31.2662 71.6209 31.2905L67.5857 33.8368L68.4998 31.0463C65.341 30.4901 62.1704 29.0547 60.3516 27.1852L58.7568 28.7962L59.1755 25.5286C58.8546 24.8303 58.7285 24.0951 58.851 23.3427C59.2789 22.3242 59.7036 21.6849 59.7036 21.6849C59.4844 22.5496 59.5973 23.3882 59.9653 24.1856L59.5466 27.4532L61.1425 25.8463C62.9614 27.7158 66.1319 29.1511 69.2907 29.7073L68.3767 32.4979L72.4118 29.9516C73.7768 29.9162 75.0458 29.6611 76.0839 29.1526L76.0772 29.1523Z",
    fill: "#210C42"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9121 25.4963C63.9121 25.4963 65.561 24.2721 65.8115 24.4291C66.0619 24.5861 66.627 26.5426 66.2677 26.9482C65.9068 27.3565 62.9785 26.1358 63.9095 25.4948L63.9121 25.4963Z",
    fill: "#2C0F59"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.4296 30.082C60.1442 30.6917 60.9373 31.6637 62.2037 32.2521C63.4701 32.8405 64.7246 32.8197 65.0113 32.2074C65.2967 31.5977 64.5036 30.6257 63.2372 30.0373C61.9734 29.4503 60.7163 29.4697 60.4296 30.082Z",
    fill: "#B940C4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8837_47745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 23,
    width: 8,
    height: 4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4872 26.4682C74.7929 22.5213 69.5032 22.872 67.5185 24.7781L74.4872 26.4682Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8837_47745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7006 24.1837C69.995 23.2882 70.9508 22.7926 71.8376 23.0759C72.723 23.3618 73.2034 24.3188 72.9116 25.2157C72.6172 26.1112 71.6614 26.6068 70.7745 26.3235C69.8892 26.0376 69.4087 25.0806 69.7006 24.1837Z",
    fill: "#E2C533"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_8837_47745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 20,
    width: 5,
    height: 4
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8353 21.0587C64.6184 18.7563 64.712 23.5423 64.712 23.5423L60.8353 21.0587Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_8837_47745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1053 21.4377C62.3335 20.7407 63.009 20.3313 63.6138 20.5265C64.2185 20.7217 64.522 21.445 64.2939 22.142C64.0657 22.8389 63.3902 23.2483 62.7854 23.0531C62.1807 22.8579 61.8772 22.1346 62.1053 21.4377Z",
    fill: "#E2C533"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1686 20.4246C71.5744 19.7504 69.846 20.0887 69.846 20.0887C69.846 20.0887 69.7604 19.1338 68.4602 18.5265L70.1057 18.9003C70.1057 18.9003 71.1785 16.413 71.7369 15.4604C72.5123 14.1371 76.7605 12.5927 77.4146 13.2933C78.0687 13.994 77.0009 17.6787 76.89 17.8593C76.7791 18.0399 73.4392 17.2511 72.8601 17.3957C72.281 17.5403 71.4856 19.126 71.4856 19.126C71.4856 19.126 72.9331 19.7081 73.1671 20.4273L73.1686 20.4246Z",
    fill: "#381169"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_8837_47745",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 13,
    width: 10,
    height: 8
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1686 20.4246C71.5744 19.7504 69.846 20.0887 69.846 20.0887C69.846 20.0887 69.7604 19.1338 68.4602 18.5265L70.1057 18.9003C70.1057 18.9003 71.1785 16.413 71.7369 15.4604C72.5123 14.1371 76.7605 12.5927 77.4146 13.2933C78.0687 13.994 77.0009 17.6787 76.89 17.8593C76.7791 18.0399 73.4392 17.2511 72.8601 17.3957C72.281 17.5403 71.4856 19.126 71.4856 19.126C71.4856 19.126 72.9331 19.7081 73.1671 20.4273L73.1686 20.4246Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_8837_47745)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.57
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9346 14.8574C74.5297 14.5555 75.1956 14.3104 75.8475 14.4211C76.9336 14.6042 77.6123 15.6649 78.1555 16.6257C78.5274 15.8669 78.8196 15.0672 79.0179 14.2462C79.2195 13.4132 79.2994 12.4431 78.7509 11.798C78.4767 11.4754 78.0821 11.283 77.6931 11.1111C76.6049 10.6256 75.4595 10.212 74.2663 10.1597C73.0732 10.1074 71.8113 10.46 70.9682 11.323C70.3116 11.9924 69.9615 12.9018 69.6857 13.8008C69.3812 14.7876 68.1507 17.6129 70.0528 17.4961C70.7849 17.4506 71.2091 16.9288 71.7017 16.4555C72.3647 15.8175 73.114 15.276 73.9331 14.8601L73.9346 14.8574Z",
    fill: "white"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2478 38.2912C48.7109 30.7601 43.1076 24.9913 35.5388 25.4796C27.9699 25.9679 21.2991 32.531 21.8358 40.0598C21.8358 40.0598 22.2935 55.3573 36.0028 67.2294C37.1306 68.058 39.1502 67.868 39.9352 66.9757C51.8342 53.4537 49.2502 38.291 49.2502 38.291L49.2478 38.2912ZM36.1523 47.7391C31.3967 48.0459 27.2697 44.4589 26.9326 39.7309C26.5956 35.0029 30.1781 30.9186 34.9313 30.6119C39.6845 30.3052 43.8139 33.892 44.151 38.62C44.488 43.348 40.9055 47.4324 36.1523 47.7391Z",
    fill: "#D95920"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8124 38.0829C50.276 30.5584 43.716 24.8567 36.1618 25.344C28.6075 25.8314 24.5984 32.6135 25.1346 40.1357C25.1346 40.1357 27.1151 57.4975 38.1706 67.0832C39.0734 67.8659 39.5493 67.5047 40.3327 66.6132C52.2078 53.1039 50.8148 38.0828 50.8148 38.0828L50.8124 38.0829Z",
    fill: "#E37230"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_8837_47745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 25,
    width: 28,
    height: 43
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8123 38.0834C50.2759 30.5589 43.7159 24.8571 36.1617 25.3445C28.6074 25.8319 22.9169 32.3264 23.4531 39.8486C23.4531 39.8486 23.9111 55.1327 37.5949 66.9953C38.4976 67.7781 39.5984 67.6066 40.3818 66.7151C52.2569 53.2058 50.8147 38.0832 50.8147 38.0832L50.8123 38.0834Z",
    fill: "#E37230"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_8837_47745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6554 38.0833C52.119 30.5587 45.9201 24.4475 38.3658 24.9349C41.7746 27.0078 50.3323 31.4298 50.4705 38.0833C50.6086 44.7367 49.6309 58.8841 38.8621 69.0182C39.7649 69.8009 41.7148 67.6893 42.4982 66.7978C54.3733 53.2885 52.6578 38.0831 52.6578 38.0831L52.6554 38.0833Z",
    fill: "#F3B34B"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8993 47.8851C44.9664 47.5584 48.7825 43.2038 48.4226 38.1589C48.0628 33.114 43.6634 29.2892 38.5962 29.6159C33.5291 29.9427 29.7131 34.2972 30.0729 39.3421C30.4328 44.387 34.8322 48.2118 39.8993 47.8851Z",
    fill: "#FAD3F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39.8993 47.8851C34.6239 45.5253 34.2928 43.2038 33.933 38.1589C33.5731 33.114 35.407 31.7522 38.5962 29.6159C33.5291 29.9427 29.7131 34.2972 30.0729 39.3421C30.4328 44.387 34.8322 48.2118 39.8993 47.8851Z",
    fill: "#B996C2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2442 37.9895C37.9298 39.5658 36.3971 40.5888 34.8207 40.2744C33.2444 39.96 32.2214 38.4273 32.5358 36.8509C32.8502 35.2746 34.3829 34.2516 35.9593 34.566C37.5356 34.8804 38.5586 36.4131 38.2442 37.9895Z",
    fill: "#D3AED6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1673 37.9895C45.8529 39.5658 44.3202 40.5888 42.7438 40.2744C41.1675 39.96 40.1445 38.4273 40.4589 36.8509C40.7733 35.2746 42.306 34.2516 43.8824 34.566C45.4587 34.8804 46.4817 36.4131 46.1673 37.9895Z",
    fill: "#D3AED6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2442 36.9759C37.9298 38.5522 36.3971 39.5752 34.8207 39.2608C33.2444 38.9464 32.2214 37.4137 32.5358 35.8374C32.8502 34.261 34.3829 33.238 35.9593 33.5524C37.5356 33.8668 38.5586 35.3996 38.2442 36.9759Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1678 36.9759C45.8534 38.5522 44.3206 39.5752 42.7443 39.2608C41.168 38.9464 40.145 37.4137 40.4594 35.8373C40.7738 34.261 42.3065 33.238 43.8828 33.5524C45.4592 33.8668 46.4822 35.3995 46.1678 36.9759Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0914 36.0792C37.8961 37.0586 36.9438 37.6942 35.9644 37.4989C34.9851 37.3035 34.3495 36.3512 34.5448 35.3718C34.7401 34.3925 35.6924 33.7569 36.6718 33.9522C37.6512 34.1475 38.2868 35.0998 38.0914 36.0792Z",
    fill: "#1D262D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M46.015 36.0792C45.8197 37.0586 44.8674 37.6942 43.888 37.4989C42.9086 37.3035 42.273 36.3512 42.4684 35.3718C42.6637 34.3925 43.616 33.7569 44.5954 33.9522C45.5748 34.1475 46.2104 35.0998 46.015 36.0792Z",
    fill: "#1D262D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_8837_47745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 24,
    width: 30,
    height: 44
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.792 38.291C50.2552 30.7599 43.5708 24.5381 36.002 25.0265C28.4332 25.5148 21.2984 32.5308 21.8351 40.0596C21.8351 40.0596 22.2928 55.3571 36.002 67.2292C37.1299 68.0578 39.1495 67.8679 39.9344 66.9755C51.8334 53.4536 50.792 38.2909 50.792 38.2909L50.792 38.291Z",
    fill: "#D95920"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_8837_47745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8609 33.0342C48.3345 23.3689 53.0344 11.4819 48.3586 6.48389C43.6828 1.48584 31.4018 5.26937 20.9283 14.9346C10.4548 24.5999 5.75485 36.4868 10.4307 41.4849C15.1065 46.483 27.3874 42.6994 37.8609 33.0342Z",
    fill: "#23094B",
    fillOpacity: 0.3
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6812 40.6997C28.6812 39.4959 29.6248 38.1329 30.0966 37.6019C30.5684 38.2509 31.512 39.7792 31.512 40.6997C31.512 43.0009 28.6812 42.9124 28.6812 40.6997Z",
    fill: "#8173DB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_8837_47745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 37,
    width: 4,
    height: 6
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6812 40.6997C28.6812 39.4959 29.6248 38.1329 30.0966 37.6019C30.5684 38.2509 31.512 39.7792 31.512 40.6997C31.512 43.0009 28.6812 42.9124 28.6812 40.6997Z",
    fill: "#581BA5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_8837_47745)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.6812 40.6997C28.6812 39.4959 29.6248 38.1329 30.0966 37.6019C29.6829 38.7149 28.4029 41.9706 30.6012 42.3602C29.9927 42.3602 28.6812 42.9124 28.6812 40.6997Z",
    fill: "#23094B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.6473,
    y: 40.4789,
    width: 10.4539,
    height: 3.60478,
    rx: 1.80239,
    fill: "white",
    stroke: "#BEACCD",
    strokeWidth: 0.360478
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.6,
    x1: 34.8274,
    y1: 42.2813,
    x2: 44.9208,
    y2: 42.2813,
    stroke: "#BEACCD",
    strokeWidth: 0.360478
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.6,
    x1: 36.8099,
    y1: 40.6591,
    x2: 36.8099,
    y2: 43.9034,
    stroke: "#BEACCD",
    strokeWidth: 0.360478
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.6,
    x1: 38.9732,
    y1: 40.6592,
    x2: 38.9732,
    y2: 43.9035,
    stroke: "#BEACCD",
    strokeWidth: 0.360478
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.6,
    x1: 40.7755,
    y1: 40.6592,
    x2: 40.7755,
    y2: 43.9035,
    stroke: "#BEACCD",
    strokeWidth: 0.360478
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.6,
    x1: 42.9385,
    y1: 40.6592,
    x2: 42.9385,
    y2: 43.9035,
    stroke: "#BEACCD",
    strokeWidth: 0.360478
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0944 38.3143C17.1068 36.2731 20.936 31.7216 20.936 31.7216C19.3719 24.7637 17.6366 15.6846 16.5392 8.63975C16.2219 6.60649 16.5722 5.88602 17.4294 5.4973C18.0087 5.23306 18.6784 5.51537 19.2458 5.80019C26.4003 9.38225 33.1736 16.698 39.0316 22.1476C40.6951 22.2939 45.0003 22.688 46.1818 22.9888C48.6386 23.6206 49.5043 23.9116 47.5072 25.7231C40.9767 31.6457 21.6767 40.9716 17.8286 41.1232C15.543 41.2129 15.0259 40.4597 16.0931 38.3118L16.0944 38.3143Z",
    fill: "#23094B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_8837_47745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 5,
    width: 34,
    height: 37
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0935 38.3141C17.106 36.273 20.9353 31.7215 20.9353 31.7215C19.3714 24.7635 17.6363 15.6843 16.5391 8.63937C16.2218 6.60608 16.5721 5.88561 17.4293 5.49691C18.0086 5.23268 18.6783 5.515 19.2458 5.79985C26.4002 9.3821 33.1734 16.698 39.0313 22.1478C40.6948 22.2942 45 22.6884 46.1815 22.9893C48.6383 23.621 49.504 23.9121 47.5068 25.7236C40.9762 31.6461 21.6758 40.9716 17.8277 41.1232C15.5421 41.2128 15.025 40.4595 16.0922 38.3117L16.0935 38.3141Z",
    fill: "#23094B"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_8837_47745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7654 30.6924C22.7161 26.3011 15.7544 4.95582 16.7967 4.25145C16.2691 4.60795 14.6847 5.46127 14.6318 6.09399C13.9574 14.0667 19.0479 23.6042 20.6431 31.4444C19.9005 32.9402 14.9905 36.2526 14.6312 37.4175C13.889 39.8433 15.113 42.9677 17.7001 42.2082C26.1592 39.7245 21.3854 44.215 23.5214 41.0107C14.9279 44.1858 19.1454 36.8188 24.7654 30.6924Z",
    fill: "#1D0A39"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M39.033 22.1497C39.033 22.1497 36.3975 18.7981 33.7472 17.1583C33.7472 17.1583 24.4439 23.8142 19.3684 24.4703C19.3684 24.4703 19.5373 28.8021 20.9374 31.7238C20.9374 31.7238 31.3202 29.8936 39.0343 22.1522L39.033 22.1497Z",
    fill: "#581BA5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_8837_47745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 17,
    width: 21,
    height: 15
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0329 22.1499C39.0329 22.1499 36.3974 18.7982 33.7471 17.1583C33.7471 17.1583 24.4437 23.8141 19.3682 24.4701C19.3682 24.4701 19.537 28.802 20.937 31.7238C20.937 31.7238 31.3199 29.8937 39.0341 22.1524L39.0329 22.1499Z",
    fill: "#581BA5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_8837_47745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 16.4124C20.9375 16.4124 24.444 23.8141 19.3684 24.4701C19.3684 24.4701 19.5372 28.8019 20.9372 31.7236C20.9372 31.7236 18.9398 40.9671 26.6543 33.2259C23.9364 29.9553 22.5546 25.3489 20.9375 16.4124Z",
    fill: "#4A0F94"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5754 29.2108C31.1703 28.904 31.8275 28.4803 32.5363 27.8951C33.1746 27.3681 33.3553 26.4527 32.9631 25.7165C32.0791 24.0571 31.1439 22.3959 30.1806 20.7836C30.006 20.4939 29.7435 20.0518 29.2709 19.8656C28.7543 19.6612 28.2388 19.8361 27.7574 20.0529C26.9586 20.4147 26.208 20.852 25.4873 21.2802C25.2012 21.4497 24.9139 21.6167 24.6228 21.7825C23.6268 22.3464 23.1888 22.9332 23.8916 24.2655L26.1802 28.6058C26.2454 28.7322 26.3738 28.9265 26.5693 29.196C26.9528 29.7327 27.6039 30.0214 28.2617 29.9521C28.8361 29.8913 29.6234 29.7018 30.5754 29.2108ZM28.1001 20.8146C28.4127 20.6722 28.7343 20.5535 28.9625 20.6429C29.1518 20.7179 29.3057 20.9555 29.4599 21.2118C30.4168 22.8117 31.3456 24.4605 32.2232 26.1075C32.4289 26.4942 32.3363 26.9719 32.0017 27.2481C30.3199 28.6364 28.9912 29.0298 28.1702 29.1174C27.8101 29.1556 27.4564 28.9991 27.2456 28.706C27.0234 28.3969 26.9457 28.2644 26.9163 28.2136L24.6277 23.8734C24.2022 23.0665 24.3076 22.918 25.0311 22.5072C25.3271 22.3389 25.617 22.1706 25.908 21.9985C26.6448 21.5651 27.3408 21.156 28.0988 20.8122L28.1001 20.8146Z",
    fill: "#FF9133"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4493 26.9269C25.7791 26.7568 26.1208 26.5492 26.5452 26.2707C26.737 26.1435 26.7911 25.8834 26.664 25.6916C26.5368 25.4998 26.2791 25.4444 26.0849 25.5728C25.2979 26.0917 24.8219 26.3371 24.1289 26.5816C23.9078 26.658 23.796 26.8976 23.8736 27.115C23.9511 27.3323 24.1896 27.4479 24.407 27.3703C24.792 27.2345 25.1147 27.0995 25.4469 26.9281L25.4493 26.9269Z",
    fill: "#FF9133"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3103 46.8553C56.5804 45.7651 56.5799 45.765 56.5794 45.7648L56.5782 45.7645L56.5749 45.7637L56.565 45.7613L56.5324 45.7536C56.5052 45.7472 56.4668 45.7384 56.4185 45.7278C56.3219 45.7065 56.1848 45.6778 56.0153 45.6461C55.6773 45.5829 55.2048 45.5069 54.6635 45.4553C53.6198 45.3557 52.1637 45.3296 50.9271 45.7822C50.2909 46.015 49.6555 46.3954 49.1851 47.0116C48.7051 47.6404 48.4667 48.4236 48.4813 49.3279C48.5063 50.8714 49.2674 52.8362 50.9052 55.3627C45.6314 57.8818 41.9879 63.2651 41.9879 69.4993C41.9879 78.1468 48.998 85.157 57.6455 85.157C66.293 85.157 73.3032 78.1468 73.3032 69.4993C73.3032 60.8519 66.293 53.8417 57.6455 53.8417C56.0447 53.8417 54.5001 54.0819 53.0456 54.5283C51.2891 51.9049 50.743 50.2592 50.7273 49.2916C50.7197 48.8185 50.839 48.5471 50.9706 48.3747C51.1118 48.1898 51.342 48.0224 51.6992 47.8916C52.4497 47.617 53.4921 47.6 54.4502 47.6914C54.9098 47.7353 55.3141 47.8003 55.6026 47.8542C55.7463 47.881 55.8599 47.9049 55.9357 47.9216C55.9735 47.9299 56.0018 47.9364 56.0196 47.9406L56.0382 47.945L56.0403 47.9455L56.0409 47.9457L56.0413 47.9458C56.6431 48.0942 57.2515 47.7271 57.4005 47.1253C57.5497 46.5232 57.1825 45.9142 56.5804 45.7651L56.3103 46.8553ZM57.6455 56.088C50.2387 56.088 44.2342 62.0925 44.2342 69.4993C44.2342 76.9062 50.2387 82.9107 57.6455 82.9107C65.0524 82.9107 71.0569 76.9062 71.0569 69.4993C71.0569 62.0925 65.0524 56.088 57.6455 56.088ZM17.5122 56.0883C10.1053 56.0883 4.10081 62.0927 4.10081 69.4996C4.10081 76.9065 10.1053 82.911 17.5122 82.911C24.919 82.911 30.9235 76.9065 30.9235 69.4996C30.9235 62.0927 24.919 56.0883 17.5122 56.0883ZM1.85449 69.4996C1.85449 60.8521 8.86467 53.842 17.5122 53.842C26.1596 53.842 33.1698 60.8521 33.1698 69.4996C33.1698 78.1471 26.1596 85.1573 17.5122 85.1573C8.86467 85.1573 1.85449 78.1471 1.85449 69.4996Z",
    fill: "#491EA1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8837_47745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalloween);
export default __webpack_public_path__ + "static/media/halloween.a355ce864b0a396cf3d2f4b960e1f0b9.svg";
export { ForwardRef as ReactComponent };